export default angular.module('TextToImage', []);
